import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { TimelineExportActions } from '../actions/timeline-export-actions';
import { AppThunk } from '../actions';

export const TimelineExportThunks = {
    timelineExportData: (
        siteId: string,
        noOfDays: number,
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(TimelineExportActions.timelineExportStarted());
       
        const payload = await ApiRequests.getAlarmTimelineExport(
            { organizationIdOrLocationIdOrSiteId: siteId, days: noOfDays },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(TimelineExportActions.timelineExportSucceeded(payload.response.data.url));
        } else {
            dispatch(TimelineExportActions.timelineExportFailed());
        }
    },
};
